import { getClientSideCookie } from '../../restclient/cookies';

export const getGoogleAnalyticsClientIdFromCookie = () => {
	const gaRaw = getClientSideCookie('_ga');
	if (!gaRaw) return null;

	const parts = gaRaw.split('.');
	// GA cookie format: GA<version>.<subVersion>.<clientId>.<timestamp>
	if (parts.length >= 4) {
		return `${parts[2]}.${parts[3]}`;
	}

	return null;
};

export const getGoogleClickIdFromCookie = () => {
	const googleClickId = getClientSideCookie('gclid');

	if (!googleClickId) return null;

	try {
		return decodeURIComponent(googleClickId);
	} catch (error) {
		return googleClickId;
	}
};
